import React from 'react';
import aboutData from '../../data/about.json';
import conferenceImg from '../../assets/images/resources/conference-one-img-1.jpg';

export default function AboutSection() {
    return (
        <section className="bsides-about" style={{position:'relative',overflow:'hidden',}}>
            <style>{`
                .bsides-about {
                    background: var(--eventflow-black);
                    padding: 100px 0 0;
                    position: relative;
                    overflow: hidden;
                }

                /* subtle purple glow top-center */
                .bsides-about::before {
                    content: '';
                    position: absolute;
                    top: -120px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 700px;
                    height: 400px;
                    background: radial-gradient(ellipse at center,
                        rgba(var(--eventflow-primary-rgb), 0.18) 0%,
                        transparent 70%);
                    pointer-events: none;
                    z-index: 0;
                }

                /* ---- text block ---- */
                .bsides-about__inner {
                    position: relative;
                    z-index: 1;
                    text-align: center;
                    max-width: 780px;
                    margin: 0 auto 48px;
                }

                .bsides-about__tag {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px;
                    font-weight: 600;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    color: var(--eventflow-base);
                    margin-bottom: 20px;
                }
                .bsides-about__tag::before,
                .bsides-about__tag::after {
                    content: '';
                    display: inline-block;
                    width: 32px;
                    height: 1px;
                    background: var(--eventflow-base);
                    opacity: 0.5;
                }

                .bsides-about__title {
                    font-family: var(--eventflow-font);
                    font-size: 56px;
                    font-weight: 800;
                    line-height: 1.1;
                    color: var(--eventflow-white);
                    margin-bottom: 20px;
                    letter-spacing: -1px;
                }
                .bsides-about__title span {
                    color: var(--eventflow-base);
                }

                .bsides-about__desc {
                    font-family: var(--eventflow-font);
                    font-size: 16px;
                    line-height: 1.75;
                    color: rgba(var(--eventflow-white-rgb), 0.6);
                    margin-bottom: 36px;
                }

                /* ---- info pills ---- */
                .bsides-about__pills {
                    display: flex;
                    justify-content: center;
                    gap: 14px;
                    flex-wrap: wrap;
                    margin-bottom: 0;
                }
                .bsides-about__pill {
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    background: rgba(var(--eventflow-white-rgb), 0.04);
                    border: 1px solid rgba(var(--eventflow-white-rgb), 0.1);
                    border-radius: 50px;
                    padding: 10px 22px;
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    color: rgba(var(--eventflow-white-rgb), 0.75);
                    transition: border-color 0.3s, background 0.3s;
                    text-decoration: none;
                }
                .bsides-about__pill:hover {
                    border-color: rgba(var(--eventflow-base-rgb), 0.5);
                    background: rgba(var(--eventflow-base-rgb), 0.06);
                    color: var(--eventflow-white);
                }
                .bsides-about__pill i {
                    color: var(--eventflow-base);
                    font-size: 14px;
                }

                /* ---- image frame ---- */
                .bsides-about__img-wrap {
                    position: relative;
                    z-index: 1;
                    margin: 60px auto 0;
                    max-width: 1000px;
                    padding: 0 20px;
                }

                /* image frame */
                .bsides-about__img-frame {
                    position: relative;
                    border-radius: 16px;
                    overflow: hidden;
                }

                .bsides-about__img-frame img {
                    width: auto;
                    max-width: 350px;
                    display: block;
                    margin: 0 auto;
                    border-radius: 16px;
                    filter: brightness(0.88) saturate(1.1);
                    transition: filter 0.4s;
                }
                .bsides-about__img-frame:hover img {
                    filter: brightness(0.95) saturate(1.2);
                }

                /* top fade overlay so image blends into section bg */
                .bsides-about__img-frame::after {
                    content: '';
                    position: absolute;
                    bottom: 0; left: 0; right: 0;
                    height: 40%;
                    background: linear-gradient(to top, var(--eventflow-black) 0%, transparent 100%);
                    pointer-events: none;
                }

                /* ---- stats bar ---- */
                .bsides-about__stats {
                    display: flex;
                    justify-content: center;
                    gap: 0;
                    position: relative;
                    z-index: 2;
                    margin-top: -2px;
                    background: rgba(var(--eventflow-white-rgb), 0.03);
                    border-top: 1px solid rgba(var(--eventflow-white-rgb), 0.07);
                    border-bottom: 1px solid rgba(var(--eventflow-white-rgb), 0.07);
                    flex-wrap: wrap;
                }
                .bsides-about__stat {
                    flex: 1;
                    min-width: 140px;
                    text-align: center;
                    padding: 32px 20px;
                    border-right: 1px solid rgba(var(--eventflow-white-rgb), 0.07);
                    transition: background 0.3s;
                }
                .bsides-about__stat:last-child { border-right: none; }
                .bsides-about__stat:hover {
                    background: rgba(var(--eventflow-base-rgb), 0.05);
                }
                .bsides-about__stat-num {
                    font-family: var(--eventflow-font);
                    font-size: 40px;
                    font-weight: 800;
                    color: var(--eventflow-white);
                    line-height: 1;
                    margin-bottom: 6px;
                    letter-spacing: -1px;
                }
                .bsides-about__stat-num span {
                    color: var(--eventflow-base);
                }
                .bsides-about__stat-label {
                    font-family: var(--eventflow-font);
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2.5px;
                    text-transform: uppercase;
                    color: rgba(var(--eventflow-white-rgb), 0.4);
                }

                @media (max-width: 768px) {
                    .bsides-about { padding: 70px 0 0; }
                    .bsides-about__title { font-size: 36px; }
                    .bsides-about__stat-num { font-size: 30px; }
                    .bsides-about__stat { min-width: 50%; }
                    .bsides-about__img-wrap { padding: 0 12px; }
                }
            `}</style>

            <div className="container">
                {/* Text block */}
                <div className="bsides-about__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="bsides-about__tag">{aboutData.section.eyebrow}</div>

                    <h2 className="bsides-about__title">
                        {aboutData.titleWhite}<br />
                        <span>{aboutData.titleAccent}</span>
                    </h2>

                    <p className="bsides-about__desc">{aboutData.description}</p>

                    {/* Info pills */}
                    <div className="bsides-about__pills">
                        <a href={`mailto:${aboutData.email}`} className="bsides-about__pill">
                            <i className="fa fa-envelope" />
                            {aboutData.email}
                        </a>
                        <span className="bsides-about__pill">
                            <i className="fa fa-map-marker-alt" />
                            {aboutData.venue}
                        </span>
                        <a href={`tel:${aboutData.phone}`} className="bsides-about__pill">
                            <i className="fa fa-phone" />
                            {aboutData.phone}
                        </a>
                    </div>
                </div>
            </div>

            {/* Conference image */}
            <div className="bsides-about__img-wrap wow fadeInUp" data-wow-delay="200ms">
                <div className="bsides-about__img-frame">
                    <img src={aboutData.image || conferenceImg} alt="BSides Coimbatore Conference" />
                </div>
            </div>

            {/* Stats bar */}
            <div className="bsides-about__stats wow fadeInUp" data-wow-delay="300ms">
                {aboutData.stats.map((s, i) => (
                    <div className="bsides-about__stat" key={i}>
                        <div className="bsides-about__stat-num">{s.number}</div>
                        <div className="bsides-about__stat-label">{s.label}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}


